import { Spin, Modal } from "antd";
import React from "react";
import toast from "react-hot-toast";

export default async function OpenSecurePdf(fileName, token) {
  if (!fileName || !token) {
    toast.error("Fichier ou Token manquant");
    return;
  }

  const loadingModal = Modal.info({
    title: "Ouverture sécurisée de votre document...",
    content: (
      <div style={{ textAlign: "center", marginTop: "16px" }}>
        <Spin size="large" />
        <p style={{ marginTop: "12px", fontSize: "14px", color: "#555" }}>
          Merci de patienter.
        </p>
      </div>
    ),
    okButtonProps: { style: { display: "none" } },
    centered: true,
    closable: false,
    maskClosable: false,
  });
  
  try {
    const response = await fetch(`${process.env.REACT_APP_API_URL}/files/print/${fileName}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      throw new Error("Erreur lors du téléchargement du fichier");
    }

    const blob = await response.blob();
    const url = URL.createObjectURL(blob);

    loadingModal.destroy();

    window.open(url, '_blank');
  } catch (error) {
    console.error("Erreur d'ouverture du document :", error);
    loadingModal.destroy();
    toast.error("Erreur d'ouverture du document");
  }
}
